import Prescriptions from './Prescriptions'
import Patients from './Patients'
import Auth from './Auth'

export default {
    Prescriptions,
    Patients,
    Auth
}
